// import { useEffect, useMemo, useState } from "react";
// import { useParams, Link } from "react-router-dom";
// import { db } from "../../firebase";
// import {
//   doc,
//   getDoc,
//   collection,
//   query,
//   where,
//   getDocs,
// } from "firebase/firestore";

// function BundleRow({ g, cards }) {
//   const nav = useNavigate();
//   const any = g.any;
//   const unitCurrency = any.currency || "USD";
//   const statuses = new Set(g.tickets.map((t) => t.status));
//   const isApproved = statuses.has("agent_approved");
//   const isSubmitted = statuses.has("payment_submitted");
//   const isPaid = g.tickets.every((t) => t.status === "payment_approved");

//   return (
//     <div className="p-4 bg-slate-800 rounded-2xl ring-1 ring-slate-700">
//       <div className="flex items-center justify-between mb-1">
//         <div className="font-semibold">Agent bundle • {any.agentName}</div>
//         <div className="text-sm">
//           Total:{" "}
//           <b>
//             {unitCurrency} {g.total.toFixed(2)}
//           </b>{" "}
//           · {g.tickets.length} ticket(s)
//         </div>
//       </div>
//       <div className="text-xs text-slate-400">
//         {g.tickets.map((t) => (
//           <div key={t.id}>
//             Card {t.cardId.slice(0, 8)}… —{" "}
//             {t.numbers?.sort((a, b) => a - b).join(", ")} (
//             {t.status.replace("_", " ")})
//           </div>
//         ))}
//       </div>

//       <div className="mt-3">
//         {isPaid ? (
//           <span className="px-2 py-1 rounded bg-blue-500/20 text-blue-200 text-sm">
//             Paid — awaiting draw
//           </span>
//         ) : isSubmitted ? (
//           <span className="px-2 py-1 rounded bg-indigo-500/20 text-indigo-200 text-sm">
//             Payment submitted — reviewing
//           </span>
//         ) : isApproved ? (
//           <button
//             onClick={() => nav(`/lottery/pay/bundle/${g.key}`)}
//             className="px-3 py-2 rounded-xl bg-lime-400 text-black font-semibold"
//           >
//             Pay once for all
//           </button>
//         ) : (
//           <span className="text-sm text-slate-300">
//             Awaiting agent approval
//           </span>
//         )}
//       </div>
//     </div>
//   );
// }

// function maskPhone(phone = "", revealAll = false) {
//   if (!phone) return "-";
//   if (revealAll) return phone;
//   const digits = phone.replace(/\D/g, "");
//   if (digits.length <= 2)
//     return "*".repeat(Math.max(0, digits.length - 1)) + digits.slice(-1);
//   const masked = "*".repeat(Math.max(0, digits.length - 2)) + digits.slice(-2);
//   return phone.replace(digits, masked);
// }

// export default function MyTicketDetail({ user }) {
//   const { ticketId } = useParams();
//   const [ticket, setTicket] = useState(null);
//   const [card, setCard] = useState(null);
//   const [numInfo, setNumInfo] = useState({}); // { [num]: { userName, phone, userUid, status, ticketId } }
//   const [selected, setSelected] = useState(null);

//   // Load ticket, card, and ownership map for the whole card
//   useEffect(() => {
//     (async () => {
//       const snap = await getDoc(doc(db, "tickets", ticketId));
//       if (!snap.exists()) return;
//       const t = { id: snap.id, ...snap.data() };
//       setTicket(t);

//       const c = await getDoc(doc(db, "cards", t.cardId));
//       if (c.exists()) setCard({ id: c.id, ...c.data() });

//       // Build ownership map from ALL tickets on this card
//       const qy = query(
//         collection(db, "tickets"),
//         where("cardId", "==", t.cardId)
//       );
//       const ts = await getDocs(qy);

//       const OWNERSHIP_STATUSES = new Set([
//         "payment_approved", // sold (incl. agent direct allocate)
//         "agent_approved", // hold started
//         "payment_submitted", // awaiting approval
//       ]);

//       const map = {};
//       ts.forEach((d) => {
//         const x = d.data();
//         if (OWNERSHIP_STATUSES.has(x.status)) {
//           (x.numbers || []).forEach((n) => {
//             map[n] = {
//               userName: x.userName || x.userUid?.slice(0, 6),
//               phone: x.phone || x.userMobileE164 || x.userMobile || "",
//               userUid: x.userUid || null,
//               status: x.status,
//               ticketId: d.id,
//             };
//           });
//         }
//       });

//       setNumInfo(map);
//     })();
//   }, [ticketId]);

//   // Numbers on the current ticket
//   const ticketNums = useMemo(
//     () => new Set(ticket?.numbers || []),
//     [ticket?.numbers]
//   );

//   // Any numbers on this card that belong to THIS user (agent-allocated or via other tickets)
//   const myAssignedAcrossCard = useMemo(() => {
//     const s = new Set();
//     if (user?.uid) {
//       Object.entries(numInfo).forEach(([k, info]) => {
//         if (info?.userUid === user.uid) s.add(Number(k));
//       });
//     }
//     return s;
//   }, [numInfo, user?.uid]);

//   // Final "your numbers" = union of this ticket + any of your allocations on the card
//   const yourNums = useMemo(() => {
//     const s = new Set(ticketNums);
//     myAssignedAcrossCard.forEach((n) => s.add(n));
//     return s;
//   }, [ticketNums, myAssignedAcrossCard]);

//   const filled = useMemo(() => new Set(card?.filled || []), [card?.filled]);
//   const locked = useMemo(() => new Set(card?.locked || []), [card?.locked]);

//   const allNums = [...Array(100).keys()];

//   const cellClass = (n) => {
//     if (yourNums.has(n)) return "bg-red-400 text-black font-bold"; // Your numbers
//     if (filled.has(n)) return "bg-lime-400 text-black font-bold"; // Sold
//     if (locked.has(n)) return "bg-amber-400/80 text-black"; // On hold
//     return "bg-slate-700 text-white/90 hover:bg-lime-400";
//   };

//   const infoFor = (n) => numInfo[n];

//   return (
//     <div className="max-w-5xl mx-auto mt-8 md:mt-16">
//       <div className="flex items-center justify-between mb-4">
//         <h1 className="text-2xl font-bold">
//           Card #{ticket?.cardId?.slice(0, 8)}… · Ticket{" "}
//           {ticket?.id?.slice(0, 8)}…
//         </h1>
//         <Link to="/my-tickets" className="px-3 py-2 rounded-xl bg-slate-700">
//           Back
//         </Link>
//       </div>

//       {/* Stats row */}
//       <div className="grid sm:grid-cols-3 gap-3 mb-6">
//         <div className="p-3 rounded-xl bg-slate-800">
//           <div className="text-xs text-slate-400">Your numbers</div>
//           <div className="text-lg font-semibold">
//             {Array.from(yourNums)
//               .sort((a, b) => a - b)
//               .join(", ") || "-"}
//           </div>
//         </div>
//         <div className="p-3 rounded-xl bg-slate-800">
//           <div className="text-xs text-slate-400">Status</div>
//           <div className="text-lg font-semibold capitalize">
//             {ticket?.status?.replace("_", " ") || "-"}
//           </div>
//         </div>
//         <div className="p-3 rounded-xl bg-slate-800">
//           <div className="text-xs text-slate-400">Draw</div>
//           <div className="text-lg font-semibold">
//             {card?.drawAt
//               ? new Date(
//                   card.drawAt?.toDate?.() || card.drawAt
//                 ).toLocaleTimeString()
//               : "-"}
//           </div>
//         </div>
//       </div>

//       {/* 10x10 grid */}
//       <div className="rounded-2xl bg-slate-800 p-4">
//         <div className="grid grid-cols-10 gap-1 select-none">
//           {allNums.map((n) => {
//             const info = infoFor(n);
//             const clickable = !!info;
//             return (
//               <button
//                 key={n}
//                 onClick={() => clickable && setSelected(n)}
//                 className={`h-10 rounded flex items-center justify-center text-sm ${cellClass(
//                   n
//                 )} ${clickable ? "cursor-pointer" : "cursor-default"}`}
//                 title={
//                   info
//                     ? `${info.userName || "Player"} (${String(
//                         info.status || ""
//                       ).replace("_", " ")})`
//                     : ""
//                 }
//               >
//                 {n.toString().padStart(2, "0")}
//               </button>
//             );
//           })}
//         </div>

//         {/* Legend */}
//         <div className="flex gap-4 mt-4 text-xs text-slate-300">
//           <span className="inline-flex items-center gap-2">
//             <span className="inline-block w-4 h-4 rounded bg-red-400" /> Your
//             numbers
//           </span>
//           <span className="inline-flex items-center gap-2">
//             <span className="inline-block w-4 h-4 rounded bg-lime-400" /> Sold
//           </span>
//           <span className="inline-flex items-center gap-2">
//             <span className="inline-block w-4 h-4 rounded bg-amber-400" /> On
//             hold / awaiting payment
//           </span>
//         </div>
//       </div>

//       {bundles
//         .filter(({ tickets }) => {
//           const cardDrawn = tickets.some(
//             (t) => cards[t.cardId]?.status === "drawn"
//           );
//           const finalised = tickets.every((t) =>
//             ["expired", "payment_declined", "void_drawn"].includes(t.status)
//           );
//           return !cardDrawn && !finalised;
//         })
//         .map((g) => (
//           <BundleRow key={g.key} g={g} cards={cards} />
//         ))}

//       {/* Click drawer */}
//       {selected !== null && (
//         <div className="mt-4 p-4 rounded-2xl bg-slate-900 border border-slate-700">
//           <div className="flex items-center justify-between mb-2">
//             <div className="text-lg font-bold">
//               Number {selected.toString().padStart(2, "0")}
//             </div>
//             <button
//               onClick={() => setSelected(null)}
//               className="px-2 py-1 rounded bg-slate-700"
//             >
//               Close
//             </button>
//           </div>
//           {(() => {
//             const info = infoFor(selected);
//             if (!info)
//               return <div className="text-slate-300 text-sm">Available</div>;
//             const isYou = info.userUid === user?.uid;
//             return (
//               <div className="text-sm text-slate-200 space-y-1">
//                 <div>
//                   Buyer: <b>{info.userName || "Player"}</b>{" "}
//                   {isYou && (
//                     <span className="text-xs text-lime-300">(you)</span>
//                   )}
//                 </div>
//                 <div>
//                   Mobile: <b>{maskPhone(info.phone, isYou)}</b>
//                 </div>
//                 <div>
//                   Status:{" "}
//                   <b className="capitalize">
//                     {String(info.status || "").replace("_", " ")}
//                   </b>
//                 </div>
//                 <div className="text-xs text-slate-400">
//                   Ticket: {info.ticketId.slice(0, 8)}…
//                 </div>
//               </div>
//             );
//           })()}
//         </div>
//       )}
//     </div>
//   );
// }

import { useEffect, useMemo, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { db } from "../../firebase";
import {
  doc,
  getDoc,
  collection,
  query,
  where,
  getDocs,
} from "firebase/firestore";

function maskPhone(phone = "", revealAll = false) {
  if (!phone) return "-";
  if (revealAll) return phone;
  const digits = phone.replace(/\D/g, "");
  if (digits.length <= 2)
    return "*".repeat(Math.max(0, digits.length - 1)) + digits.slice(-1);
  const masked = "*".repeat(Math.max(0, digits.length - 2)) + digits.slice(-2);
  return phone.replace(digits, masked);
}

export default function MyTicketDetail({ user }) {
  const { ticketId } = useParams();
  const [ticket, setTicket] = useState(null);
  const [card, setCard] = useState(null);
  const [numInfo, setNumInfo] = useState({}); // { [num]: { userName, phone, userUid, status, ticketId } }
  const [selected, setSelected] = useState(null);

  // Load ticket, card, and ownership map for the whole card
  useEffect(() => {
    (async () => {
      const snap = await getDoc(doc(db, "tickets", ticketId));
      if (!snap.exists()) return;
      const t = { id: snap.id, ...snap.data() };
      setTicket(t);

      const c = await getDoc(doc(db, "cards", t.cardId));
      if (c.exists()) setCard({ id: c.id, ...c.data() });

      // Build ownership map from ALL tickets on this card
      const qy = query(
        collection(db, "tickets"),
        where("cardId", "==", t.cardId)
      );
      const ts = await getDocs(qy);

      const OWNERSHIP_STATUSES = new Set([
        "payment_approved", // sold (incl. agent direct allocate)
        "agent_approved", // hold started
        "payment_submitted", // awaiting approval
      ]);

      const map = {};
      ts.forEach((d) => {
        const x = d.data();
        if (OWNERSHIP_STATUSES.has(x.status)) {
          (x.numbers || []).forEach((n) => {
            map[n] = {
              userName: x.userName || x.userUid?.slice(0, 6),
              phone: x.phone || x.userMobileE164 || x.userMobile || "",
              userUid: x.userUid || null,
              status: x.status,
              ticketId: d.id,
            };
          });
        }
      });

      setNumInfo(map);
    })();
  }, [ticketId]);

  // Numbers on the current ticket
  const ticketNums = useMemo(
    () => new Set(ticket?.numbers || []),
    [ticket?.numbers]
  );

  // Any numbers on this card that belong to THIS user (agent-allocated or via other tickets)
  const myAssignedAcrossCard = useMemo(() => {
    const s = new Set();
    if (user?.uid) {
      Object.entries(numInfo).forEach(([k, info]) => {
        if (info?.userUid === user.uid) s.add(Number(k));
      });
    }
    return s;
  }, [numInfo, user?.uid]);

  // Final "your numbers" = union of this ticket + any of your allocations on the card
  const yourNums = useMemo(() => {
    const s = new Set(ticketNums);
    myAssignedAcrossCard.forEach((n) => s.add(n));
    return s;
  }, [ticketNums, myAssignedAcrossCard]);

  const filled = useMemo(() => new Set(card?.filled || []), [card?.filled]);
  const locked = useMemo(() => new Set(card?.locked || []), [card?.locked]);

  const allNums = [...Array(100).keys()];

  const cellClass = (n) => {
    if (yourNums.has(n)) return "bg-red-400 text-black font-bold"; // Your numbers
    if (filled.has(n)) return "bg-lime-400 text-black font-bold"; // Sold
    if (locked.has(n)) return "bg-amber-400/80 text-black"; // On hold
    return "bg-slate-700 text-white/90 hover:bg-lime-400"; // Available
  };

  const infoFor = (n) => numInfo[n];

  return (
    <div className="max-w-5xl mx-auto mt-8 md:mt-16">
      <div className="flex items-center justify-between mb-4">
        <h1 className="text-2xl font-bold">
          Card #{ticket?.cardId?.slice(0, 8)}… · Ticket{" "}
          {ticket?.id?.slice(0, 8)}…
        </h1>
        <Link to="/my-tickets" className="px-3 py-2 rounded-xl bg-slate-700">
          Back
        </Link>
      </div>

      {/* Stats row */}
      <div className="grid sm:grid-cols-3 gap-3 mb-6">
        <div className="p-3 rounded-xl bg-slate-800">
          <div className="text-xs text-slate-400">Your numbers</div>
          <div className="text-lg font-semibold">
            {Array.from(yourNums)
              .sort((a, b) => a - b)
              .join(", ") || "-"}
          </div>
        </div>
        <div className="p-3 rounded-xl bg-slate-800">
          <div className="text-xs text-slate-400">Status</div>
          <div className="text-lg font-semibold capitalize">
            {ticket?.status?.replace("_", " ") || "-"}
          </div>
        </div>
        <div className="p-3 rounded-xl bg-slate-800">
          <div className="text-xs text-slate-400">Draw</div>
          <div className="text-lg font-semibold">
            {card?.drawAt
              ? new Date(
                  card.drawAt?.toDate?.() || card.drawAt
                ).toLocaleTimeString()
              : "-"}
          </div>
        </div>
      </div>

      {/* 10x10 grid */}
      <div className="rounded-2xl bg-slate-800 p-4">
        <div className="grid grid-cols-10 gap-1 select-none">
          {allNums.map((n) => {
            const info = infoFor(n);
            const clickable = !!info;
            return (
              <button
                key={n}
                onClick={() => clickable && setSelected(n)}
                className={`h-10 rounded flex items-center justify-center text-sm ${cellClass(
                  n
                )} ${clickable ? "cursor-pointer" : "cursor-default"}`}
                title={
                  info
                    ? `${info.userName || "Player"} (${String(
                        info.status || ""
                      ).replace("_", " ")})`
                    : ""
                }
              >
                {n.toString().padStart(2, "0")}
              </button>
            );
          })}
        </div>

        {/* Legend */}
        <div className="flex gap-4 mt-4 text-xs text-slate-300">
          <span className="inline-flex items-center gap-2">
            <span className="inline-block w-4 h-4 rounded bg-red-400" /> Your
            numbers
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block w-4 h-4 rounded bg-lime-400" /> Sold
          </span>
          <span className="inline-flex items-center gap-2">
            <span className="inline-block w-4 h-4 rounded bg-amber-400" /> On
            hold / awaiting payment
          </span>
        </div>
      </div>

      {/* Click drawer */}
      {selected !== null && (
        <div className="mt-4 p-4 rounded-2xl bg-slate-900 border border-slate-700">
          <div className="flex items-center justify-between mb-2">
            <div className="text-lg font-bold">
              Number {selected.toString().padStart(2, "0")}
            </div>
            <button
              onClick={() => setSelected(null)}
              className="px-2 py-1 rounded bg-slate-700"
            >
              Close
            </button>
          </div>
          {(() => {
            const info = infoFor(selected);
            if (!info)
              return <div className="text-slate-300 text-sm">Available</div>;
            const isYou = info.userUid === user?.uid;
            return (
              <div className="text-sm text-slate-200 space-y-1">
                <div>
                  Buyer: <b>{info.userName || "Player"}</b>{" "}
                  {isYou && (
                    <span className="text-xs text-lime-300">(you)</span>
                  )}
                </div>
                <div>
                  Mobile: <b>{maskPhone(info.phone, isYou)}</b>
                </div>
                <div>
                  Status:{" "}
                  <b className="capitalize">
                    {String(info.status || "").replace("_", " ")}
                  </b>
                </div>
                <div className="text-xs text-slate-400">
                  Ticket: {info.ticketId.slice(0, 8)}…
                </div>
              </div>
            );
          })()}
        </div>
      )}
    </div>
  );
}
